import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=482f55e4&scoped=true&"
import script from "./CompanyItem.vue?vue&type=script&lang=js&"
export * from "./CompanyItem.vue?vue&type=script&lang=js&"
import style0 from "./CompanyItem.vue?vue&type=style&index=0&id=482f55e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f55e4",
  null
  
)

export default component.exports